import { Component, h, Prop, Event, EventEmitter, State, Method } from '@stencil/core';
import {star} from '../../utils/utils'

@Component({
  tag: 'jackery-rating',
  styleUrl: 'jackery-rating.css',
  shadow: true,
})

export class JackeryRating {
  @Prop({mutable: true}) score: number;
  /**
  * Prop mode 类型【展示 | 评分】mode__edit编辑模式
  */
  @Prop() mode: string;

  /**
  * State hoverIndex 评分模式下 hover分数
  */
  @State() hoverIndex: number = 0;

  @Event() ratingChange: EventEmitter<number>;

  @Method()
  public async handleReset() { // 重置分数
    this.hoverIndex = 0
    this.score = 0
  }

  handleStarClick(starValue: number) {
    if(this.mode !== 'mode__edit') return
    this.score = starValue;
    this.ratingChange.emit(this.score);
  }

  handleStarOver(starValue: number) {
    if(this.mode !== 'mode__edit' || this.score >= starValue) return
    this.hoverIndex = starValue
  }

  handleStarOut() {
    if(this.mode !== 'mode__edit') return
    this.hoverIndex = 0
  }

  componentWillLoad() {
    if(this.mode === 'mode__edit') {
      this.score = 0
    }
  }

  render() {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(<span 
        class={{
          'star-filled': i <= this.score, 
          'star-empty': i > this.score, 
          'start-handing': this.hoverIndex >= i
        }}
        onClick={() => this.handleStarClick(i)}
        onMouseOver={() => this.handleStarOver(i)}
        onMouseOut={() => this.handleStarOut()}
        innerHTML={star()}></span>);
    }

    return (
      <div class={`star-ratings ${this.mode}`}>
        {stars}
      </div>
    );
  }
}
